<template>
  <div class="code-confirm">
    <div class="inputs-block">
      <form @submit.prevent="codeIsInvalid ? null : submitCode()">
        <input
          type="text"
          id="input-code"
          name="input-code"
          :autofocus="true"
          maxlength="6"
          @focus="state.isFocus = true"
          @blur="state.isFocus = false"
          v-model="state.code"
        />
      </form>
      <label
        v-for="elt in 6"
        :key="elt"
        for="input-code"
        :id="`number-${elt}`"
        class="number-container"
        :class="{
          focus: state.code.length + 1 === elt && state.isFocus,
          fill: state.code.length + 1 > elt && state.isFocus,
        }"
      >
        {{ state.code[elt - 1] }}
      </label>
    </div>
    <div class="btn-group">
      <p v-if="state.code.length === 6 && codeIsInvalid" class="red-color bold">
        Code non valide
      </p>
      <Button
        class="primary"
        label="Confirmer le code"
        :loading="isLoading"
        :disabled="codeIsInvalid || state.code === state.lastCodeSubmit"
        @click="submitCode"
      />
      <Button
        v-if="route.name !== 'registerPage'"
        class="secondary outline icon icon-left"
        label="Revenir à mes informations"
        icon="bi-arrow-left"
        @click="emits('back')"
      />
    </div>
    <p>Vous n'avez rien reçu ?</p>
    <p class="primary-color bold" @click="emits('resend')">Renvoyer un code</p>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";

const emits = defineEmits(["validation", "back", "resend"]);

const route = useRoute();

const toast = useToast();

const state = reactive({
  code: "",
  isFocus: true,
  lastCodeSubmit: null,
});

const codeIsInvalid = computed(() => {
  if (state.code.length < 6) return true;

  const value = Number(state.code);

  if (isNaN(value)) return true;

  return !Number.isInteger(value);
});

const props = defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
});

function submitCode() {
  if (props.isLoading) return;

  if (state.code !== state.lastCodeSubmit) {
    state.lastCodeSubmit = state.code;
    emits("validation", state.code);
  } else {
    toast.error(
      "Code de confirmation incorrect, veuillez vérifier le code renseigné."
    );
  }
}

onMounted(() => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.code) {
    state.code = params.code;
  }
});
</script>
